module.exports = __webpack_public_path__ + "static/img/mubu.477bf45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjd_img/mubu.png
// module id = eUyv
// module chunks = 46